<template>
  <LiquidacionReportesPageLayout :title="messages.RESUMEN_PAGE_TITLE">
    <LiquidacionResumenTab />
  </LiquidacionReportesPageLayout>
</template>

<script>
import LiquidacionReportesPageLayout from "@/components/LiquidacionReportes/LiquidacionReportesPageLayout.vue";
import LiquidacionResumenTab from "@/components/LiquidacionReportes/LiquidacionResumenTab.vue";
import { MESSAGES } from "@/services/liquidacion-reportes/liquidacion-reportes.constants";

import "@/styles/liquidacion-reportes/liquidacion-reportes.css";

export default {
  name: "ReportesLiquidacionesResumen",

  components: {
    LiquidacionReportesPageLayout,
    LiquidacionResumenTab,
  },

  data() {
    return {
      messages: MESSAGES,
    };
  },
};
</script>
